import script from "./ParisGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./ParisGuide.vue?vue&type=script&lang=ts&setup=true"

import "./ParisGuide.vue?vue&type=style&index=0&id=fee5f026&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fee5f026"]])

export default __exports__